import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLParagraphElement>["className"];
  id?: HTMLAttributes<HTMLParagraphElement>["id"];
  listStyleType?: CSSProperties["listStyleType"];
  start?: number;
  style?: CSSProperties;
}>;

export default function OL({
  children,
  className,
  id,
  listStyleType,
  start,
  style,
}: Props) {
  return (
    <ol
      start={start || 1}
      className={className}
      id={id}
      style={{ ...style, listStyleType }}
    >
      {children}
    </ol>
  );
}
